/* xsell-look.js — bouton « Ajouter » du bloc « Complète ton look ».

   Le mécanisme d'ajout est repris de blocks/cross-sell-checklist.liquid, le
   cross-sell déjà en place dans ce thème et qui fonctionne. Trois détails de
   ce bloc sont indispensables et manquaient à ma première version :

     1. la route passe par Theme.routes.cart_add_url quand elle existe ;
     2. on envoie les identifiants de section des <cart-items-component>
        présents dans la page, sous la clé « sections » ;
     3. on renvoie data.sections dans l'évènement cart:update, sous la forme
        detail.data.sections — c'est CE contenu qui fait redessiner le compteur
        et le tiroir. Un évènement sans sections ne rafraîchit rien : l'article
        était bien au panier, mais rien ne bougeait à l'écran.

   Le bloc rend de VRAIS formulaires : sans ce script, ou s'il échoue, l'envoi
   natif vers /cart/add ajoute quand même l'article. */
(function () {
  if (window.__xsellLookInit) return;
  window.__xsellLookInit = true;

  function sectionsDuPanier() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids.join(',');
  }

  function annonce(form, message) {
    var cible = document.getElementById(form.getAttribute('data-statut'));
    if (cible) cible.textContent = message;
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || !form.matches || !form.matches('[data-xsell-form]')) return;
      if (typeof window.fetch !== 'function') return; // envoi natif

      evt.preventDefault();

      var bouton = form.querySelector('button[type="submit"]');
      var libelleDepart = bouton ? bouton.textContent.trim() : '';
      var variante = Number(form.querySelector('input[name="id"]').value);
      if (bouton) bouton.disabled = true;

      var route =
        (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

      fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variante, quantity: 1 }], sections: sectionsDuPanier() })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          // /cart/add.js renvoie un objet { status, description } en cas d'échec
          if (data.status) throw new Error(data.description || 'refus du panier');

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { source: 'xsell-look', itemCount: 1, sections: data.sections } }
            })
          );

          if (bouton) {
            bouton.setAttribute('aria-pressed', 'true');
            bouton.textContent = form.getAttribute('data-libelle-ajoute') || 'Ajouté';
            bouton.disabled = false;
          }
          annonce(form, form.getAttribute('data-nom') + ' ajouté au panier.');
        })
        .catch(function (err) {
          console.warn('[xsell-look] ajout en fetch impossible, envoi natif :', err);
          if (bouton) {
            bouton.disabled = false;
            bouton.textContent = libelleDepart;
          }
          form.submit(); // on ne laisse jamais le clic sans effet
        });
    },
    true // capture : passe avant un éventuel stopPropagation du thème
  );
})();
